import { createSlice } from "@reduxjs/toolkit";
import {
  GetRemotePanel, // ✅ Fixed: Corrected from getSingleServer
  blockRemotePanel,
  getAllRemotePanel,
  saveRemotePanel,
  updateRemotePanel, // ✅ Fixed: Corrected from updateServer
} from "../actions/remotePanel";

const initialState = {
  servers: [],
  singleServer: null,
  loading: false,
  error: null,
  totalCount:0,
};

const RemotePanelSlice = createSlice({
    name: "remote-panel",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        // Get Single Server
        .addCase(GetRemotePanel.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(GetRemotePanel.fulfilled, (state, action) => {
          state.loading = false;
          state.singleServer = action.payload;
        })
        .addCase(GetRemotePanel.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Save New Server
        .addCase(saveRemotePanel.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(saveRemotePanel.fulfilled, (state, action) => {
          state.loading = false;
          state.servers.push(action.payload);
        })
        .addCase(saveRemotePanel.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Get All Servers
        .addCase(getAllRemotePanel.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getAllRemotePanel.fulfilled, (state, action) => {
          const { result, totalDocument } = action.payload;
          state.servers = result;
          state.totalCount = totalDocument;
          state.loading = false;
        })
        .addCase(getAllRemotePanel.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Update Server
        .addCase(updateRemotePanel.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateRemotePanel.fulfilled, (state, action) => {
          state.loading = false;
          state.servers = state.servers.map((server) =>
            server.id === action.payload.id ? { ...server, ...action.payload } : server
          );
        })
        .addCase(updateRemotePanel.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Block Server
        .addCase(blockRemotePanel.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(blockRemotePanel.fulfilled, (state, action) => {
          state.loading = false;
          state.servers = state.servers.map((server) =>
            server.id === action.payload.id ? { ...server, blocked: true } : server
          );
        })
        .addCase(blockRemotePanel.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
  });
  

export default RemotePanelSlice.reducer;
